import { createId } from './identity';
import { adFormats, type AdFormats } from './release-features';
export type AdFormat = 'rewarded' | 'interstitial';
export interface AdAdapter { readonly mode: 'mock' | 'native' | 'unavailable'; show(format: AdFormat): Promise<{ earned: boolean; transactionId: string }>; privacy(): Promise<void> }

export class MockAds implements AdAdapter {
  readonly mode = 'mock';
  private active = false;
  constructor(private present: (format: AdFormat) => Promise<boolean>, private showPrivacy: () => void, private formats: AdFormats = adFormats) {}
  async show(format: AdFormat): Promise<{ earned: boolean; transactionId: string }> {
    if (this.active || !this.formats[format]) return { earned: false, transactionId: '' };
    this.active = true;
    const transactionId = createId();
    try { const completed = await this.present(format); return { earned: format === 'rewarded' && completed, transactionId }; }
    finally { this.active = false; }
  }
  async privacy(): Promise<void> { this.showPrivacy(); }
}

export function grantOnce(grants: string[], transactionId: string): boolean {
  if (!transactionId || grants.includes(transactionId)) return false;
  grants.push(transactionId);
  return true;
}
